import { Box } from "@mui/material";
import ReactivePopupContent from "../map/popups/ReactivePopupContent";
import type { ApiEndpoint, Entity } from "../../types";

type NonGeoEntityCardProps = {
  entity: Entity;
  entityEndpoint: ApiEndpoint;
  onClose?: () => void;
  onFindRelated?: () => void;
  isLoading?: boolean;
};

export default function NonGeoEntityCard({ entity, entityEndpoint, onClose, onFindRelated, isLoading }: NonGeoEntityCardProps) {
  return (
    <Box sx={{ pointerEvents: "auto" }}>
      <ReactivePopupContent
        entityId={entity?.id || ""}
        entityName={entity?.name || ""}
        onBack={() => {
          onClose && onClose();
        }}
        endpoint={entityEndpoint!}
        onFindRelated={onFindRelated}
        isLoading={isLoading}
      />
    </Box>
  );
}
